import TotalSelectedBadge from './TotalSelectedBadge';

export default TotalSelectedBadge;
